export default {
  menu: {
    header: null,
    footer: null,
  },
  loginStatus: false,
  currentCartPriority: -1,
  currentCart: null,
  mainContent: {
    user: null,
    settings: null,
    categories: null,
    sizeValues: null,
    cartRequest: null,
    colors: null,
    gateWays: null,
  },
};
